import { ProductVariant } from '@pageFeatures/design/designUpload/types'
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
} from 'react'

interface IBriefingFormDataProvider {
  children: ReactNode
  value: {
    briefingFormOutput: Record<string, string>
    setBriefingFormOutput: Dispatch<SetStateAction<Record<string, string>>>
    preloadedAnswers: Record<string, string | string[] | number>
    readOnlyMode?: boolean
    productOption: ProductVariant
  }
}

const BriefingFormDataContext = createContext<any>(undefined)

function BriefingFormDataProvider({
  children,
  value,
}: IBriefingFormDataProvider) {
  return (
    <BriefingFormDataContext.Provider value={value}>
      {children}
    </BriefingFormDataContext.Provider>
  )
}

function useBriefingFormOutput() {
  const context = useContext(BriefingFormDataContext)
  if (context === undefined) {
    throw new Error(
      'useBriefingFormAnswers must be used within a BriefingFormDataContext'
    )
  }
  return {
    briefingFormOutput: context.briefingFormOutput,
    setBriefingFormOutput: context.setBriefingFormOutput,
  }
}

function usePreloadedAnswers() {
  const context = useContext(BriefingFormDataContext)
  if (context === undefined) {
    throw new Error(
      'usePreloadedAnswers must be used within a BriefingFormDataContext'
    )
  }
  return context.preloadedAnswers
}

function useReadOnlyMode() {
  const context = useContext(BriefingFormDataContext)
  if (context === undefined) {
    throw new Error(
      'useReadOnlyMode must be used within a BriefingFormDataContext'
    )
  }
  return context.readOnlyMode
}

function useProductOption() {
  const context = useContext(BriefingFormDataContext)
  if (context === undefined) {
    throw new Error(
      'useProductOption must be used within a BriefingFormDataContext'
    )
  }
  return context.productOption
}

export {
  BriefingFormDataProvider,
  useBriefingFormOutput,
  usePreloadedAnswers,
  useReadOnlyMode,
  useProductOption,
}
